export var getBrandPageLoadKey = function(options) {
    var brandToken = options.brandToken, query = options.query, filters = options.filters, pageNumber = options.pageNumber, collections = options.collections;
    return "".concat(brandToken, "-").concat(query, "-").concat(filters, "-").concat(pageNumber, "-").concat(collections);
};
